import { render } from "./Panel.vue?vue&type=template&id=4c6809f4&ts=true"
import script from "./Panel.vue?vue&type=script&lang=ts"
export * from "./Panel.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__